var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPseparatoricon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 54,
    viewBox: "0 0 6 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65566",
    "data-name": "Grupo 65566",
    transform: "translate(-773 -2173)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4256",
    "data-name": "Elipse 4256",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(773 2173)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4257",
    "data-name": "Elipse 4257",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(773 2185)",
    fill: "#38d2d9",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4258",
    "data-name": "Elipse 4258",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(773 2197)",
    fill: "#38d2d9",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4259",
    "data-name": "Elipse 4259",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(773 2209)",
    fill: "#38d2d9",
    opacity: 0.299
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4260",
    "data-name": "Elipse 4260",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(773 2221)",
    fill: "#38d2d9",
    opacity: 0.096
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPseparatoricon);
export default __webpack_public_path__ + "static/media/LPseparatoricon.6330502ad2aa7617a6f634e94e7d22b7.svg";
export { ForwardRef as ReactComponent };